/* eslint-disable */
import _ from 'lodash'
function getUrl(url,query){
  if(!query)return url;
  url=url.replace(/:[^/.]*/g,function(val){
    return query[val.slice(1)]||'';
  })
  return url;
}

export function Get(url,data){
    return $.ajax({
        url:getUrl(url,data),
        method:'get',
        cache:false,
        data:data,
        dataType: 'json',
        contentType: 'application/json',
      })
}


export function Post(url,data){
    return $.ajax({
        url:getUrl(url,data),
        method:'post',
        cache:false,
        data:JSON.stringify(data),
        dataType: 'json',
        contentType: 'application/json',
      })
}


export function GetChecked(url,data){
    if(data){
      if(data=='tender'){
        return Get(url,data)
        .fail(async function(res){
              if(res.status==306){
                //返回yc登录  
                //service确认登录后返回的页面
                var url=format.call("{host}/cas/login?sysid=ipu&verify_code=usercenter&service={yc}%2Fyuncai%2FSSO%2Flogin.jsp%3Fr%3D{base64}&registertype=72941b226fa7bff1fcac9ec5ccba2d05038cd881",{
                  base64:await getBase64(),
                  host: getHost(),
                  yc:getYc()
                })
                window.location.href=url;
              }
              return res;
        })
      }else{
        if(data == "jinansteel"){
          return Get(url,data)
          .fail(async function(res){
                if(res.status==306){
                  var base64 = await getBase64(),
                       host= getHost(),
                       yc=getYc();
                  //根据data返回相应的登录页面
                  //service确认登录后返回的页面
                  var url=`${host}/cas/login?sysid=ipu&ipuid=jinansteel&verify_code=usercenter&service=${yc}%2Fyuncai%2FSSO%2Flogin.jsp%3Fr%3D${base64}&registertype=72941b226fa7bff1fcac9ec5ccba2d05038cd881`;
                  window.location.href=url;
                }
                return res;
          })
        }else if(data == "nfsn"){
          return Get(url,data)
          .fail(async function(res){
                if(res.status==306){
                  //返回南方水泥登录页 ipuid=nfsn
                  var url=format.call("{host}/cas/login?sysid=ipu&ipuid=nfsn&verify_code=usercenter&service={yc}%2Fyuncai%2FSSO%2Flogin.jsp%3Fr%3D{base64}&registertype=72941b226fa7bff1fcac9ec5ccba2d05038cd881",{
                    base64:await getBase64(),
                    host: getHost(),
                    yc:getYc()
                  })
                  window.location.href=url;
                }
                return res;
          })
        }else{
          return Get(url,data)
          .fail(async function(res){
                if(res.status==306){
                  var base64 = await getBase64(),
                       host= getHost(),
                       yc=getYc();
                  //根据data返回相应的登录页面
                  //service确认登录后返回的页面
                  var url=`${host}/cas/login?sysid=ipu&verify_code=usercenter&service=${yc}%2Fyuncai%2FSSO%2Flogin.jsp%3Fr%3D${base64}&registertype=72941b226fa7bff1fcac9ec5ccba2d05038cd881`;
                  window.location.href=url;
                }
                return res;
          })
        } 
     }
    }else{
      return Get(url,data)
      .fail(async function(res){
            if(res.status==306){
              //返回南方水泥登录页 ipuid=nfsn
              var url=format.call("{host}/cas/login?sysid=ipu&ipuid=nfsn&verify_code=usercenter&service={yc}%2Fyuncai%2FSSO%2Flogin.jsp%3Fr%3D{base64}&registertype=72941b226fa7bff1fcac9ec5ccba2d05038cd881",{
                base64:await getBase64(),
                host: getHost(),
                yc:getYc()
              })
              window.location.href=url;
            }
            return res;
      })
    }
}

function getYc(){
  return window.location.protocol+"%2f%2f"+window.location.host
}

function getHost(){
    //线上环境
    if(window.location.host=="yc.yonyoucloud.com"){
      return "https://euc.yonyoucloud.com";  
    }else{
      return "http://idtest.yyuap.com"
    }
}

async function  getBase64(){
  var data= await Get('/yuncai/util/getrurl?url='+window.location.href);
  return data.data;
}

function format(args) {
    var result = this;
    if (arguments.length > 0) {    
        if (arguments.length == 1 && typeof (args) == "object") {
            for (var key in args) {
                if(args[key]!=undefined){
                    var reg = new RegExp("({" + key + "})", "g");
                    result = result.replace(reg, args[key]);
                }
            }
        }
        else {
            for (var i = 0; i < arguments.length; i++) {
                if (arguments[i] != undefined) {
                    //var reg = new RegExp("({[" + i + "]})", "g");//这个在索引大于9时会有问题，谢谢何以笙箫的指出
　　　　　　　　　　　　var reg= new RegExp("({)" + i + "(})", "g");
                    result = result.replace(reg, arguments[i]);
                }
            }
        }
    }
    return result;
}


// WEBPACK FOOTER //
// ./src/pages/bidding_Apply/io.js